// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"361":"e6b75fd3","7214":"e4d0b000"}[chunkId] || chunkId) + "." + {"361":"58f71cc97c5ac626","2406":"c3eaae6ce9c59167","3494":"d76b24ca50fd179a","6153":"f24c4eb82b56e2c7","7214":"eff0e185f78d176a","7763":"d7c56be8af98581c"}[chunkId] + ".js";
};